import { reduce } from "lodash";
import { thor } from "../../typings/thor";
import { HttpStatusCode } from "../../thor.enums";
import "./live.resource";

export class LiveService {
    public static $inject: string[] = [
        "$q",
        "$log",
        "$http",
        "configService",
        "liveOperatorsResource",
        "liveSaleResource"
    ];

    constructor(
        private $q: ng.IQService,
        private $log: ng.ILogService,
        private $http: ng.IHttpService,
        private config,
        private liveOperatorsRes,
        private liveSaleRes
    ) { }

    public getLiveOperators(organizationId: number) {
        return this.liveOperatorsRes({ "x-organization": organizationId })
            .get()
            .$promise
            .catch(error => {
                this.$log.error("Error while fetching operators", error);
                return this.$q.reject(error);
            });
    }

    public getLiveSale(saleId: number) {
        return this.liveSaleRes()
            .get({ id: saleId })
            .$promise
            .catch(error => {
                this.$log.error(`Error while fetching sale Live ${saleId}`, error);
                return this.$q.reject(error);
            });
    }

    public updateLiveSale(saleId: number, body) {
        return this.liveSaleRes()
            .patch({ id: saleId }, body)
            .$promise
            .catch(error => {
                this.$log.error(`Error while updating sale Live ${saleId}`, error);
                return this.$q.reject(error);
            });
    }

    public getSecretOrders(saleId: number) {
        return this.$http.get(
            `${ this.config.liveLegacyApi.url }/v1/sales/${saleId}/items`
        )
            .then(result => result.data)
            .catch(error => {
                this.$log.error(`Error while getting secret order from sale ${ saleId }`, error);
            });
    }

    public getSaleCountSecretOrders(saleId: number) {
        const deferred = this.$q.defer();
        this.getSecretOrders(saleId)
            .then((secretOrders: thor.SecretOrdersLiveLegacy) => {
                const secretOrdersCount = reduce(
                    secretOrders,
                    (result, value: thor.SecretOrderLiveLegacy) => result += value.count_secret_orders,
                    0
                );
                deferred.resolve(secretOrdersCount);
            });

        return deferred.promise;
    }

    public setOffered(saleId: number, organizationId: number, body) {
        const deferred = this.$q.defer();
        this.$http
            .post(`${this.config.contentApi.url}/v1/sales/${saleId}/live/set-offered`, body, {
                headers: { "x-organization": organizationId }
            })
            .then(res => (res?.status === HttpStatusCode.NoContent ? deferred.resolve() : deferred.reject()));
        return deferred.promise;
    }
}

angular
    .module("thor.core.live.service", [
        "thor.core.live.resource"
    ])
    .service("liveService", LiveService);
